import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { IoCloseCircleOutline } from "react-icons/io5";
import TextField from "@mui/material/TextField";
import { toast, ToastContainer } from "react-toastify";
import { useDispatch } from "react-redux";
import { addNewVehicleGroups } from "../store/slices/thunk"; // your thunk file

import "./main.scss";
import AddIcon from '@mui/icons-material/Add';
import Spinner from "react-bootstrap/esm/Spinner";

const style = {
  position: "absolute",
  top: "50%", 
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, sm: 500 },
  bgcolor: "background.paper",
  boxShadow: '1px -1px 24px 20px rgb(113 113 113 / 30%);' ,
  p: 2,
};

export default function GroupModal({
  onSave,
}: {
  onSave: (data: any) => void;
}) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const dispatch: any = useDispatch();
  const [loading, setLoading] = React.useState(false); 

  const [addvehicleGroup, setAddVehicleGroup] = React.useState({
    name: "",
    description: "",
    _id: "",
  });

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setAddVehicleGroup((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const { name, description } = addvehicleGroup;
  

    if (name.trim() === "" || description.trim() === "") {
      toast.error("Fill all required fields!");
      return;
    }
    setLoading(true); // Start loading state

    try {
      const res: any = await dispatch(addNewVehicleGroups(addvehicleGroup));
      if (res.data && res.isSuccess) {
        toast.success("Vehicle Group Added!");

        if (onSave) onSave(addvehicleGroup); // pass to parent
        handleClose();
        setAddVehicleGroup({ name: "", description: "", _id: "" }); // reset
      } else {
        toast.error("Vehicle Group Not Added!");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong!");
    } finally {
      setLoading(false); // Stop loading state
    }
  };

  return (
    <div>
      <ToastContainer />
      <Button style={{background:"#16a34a", color:"#fff", border:"none", borderRadius:"10px"}} onClick={handleOpen}> <AddIcon/>Add New Group</Button>
      <Modal
      className="rounded-2 "
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="rounded-3 ">
          <Typography id="modal-modal-title" className="rounded-2 ">
            <div className="Group">
              <h3 className="fw-bold">Add New Group</h3>
              <div
                className="icon"
                style={{ cursor: "pointer" }}
                onClick={handleClose}
              >
                <IoCloseCircleOutline size={24} />
              </div>
            </div>
          </Typography>
          <Typography id="modal-modal-description mt-5">
            <h6>Name</h6>
            <div className="Group mb-3 ">
              <div className="input w-100">
                <TextField
                  label="Name"
                  variant="outlined"
                  name="name"
                  value={addvehicleGroup.name}
                  onChange={handleChange}
                  fullWidth
                />
              </div>
            </div>
             <h6>Description</h6>
            <div className="Group">
                <div className="input w-100">
                <TextField
                  label="Enter Description"
                  variant="outlined"
                  name="description"
                  value={addvehicleGroup.description}
                  onChange={handleChange}
                  fullWidth
                />
              </div>
              
            </div>
            <div className="Group Mar d-flex justify-content-end">
             
               <Button className="save"  onClick={handleSubmit} disabled={loading} style={{ textTransform: "none" }}>
    {loading ? (
      <>
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
          className="me-2"
        />
        { "Saveing..."}
      </>
    ) : (
       "Save"
    )}
  </Button>

            </div>
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}
